import axiosInstance from '@/plugins/api/axiosInstance';

export default function emailSetup() {
    return {
        get,
        create,
        update,
        remove
    };

    function get() {
        return axiosInstance.get(`email-config/get`);
    }

    function create(data) {
        return axiosInstance.post('email-config/create', data);
    }

    function update(data) {
        return axiosInstance.patch('email-config/update', data);
    }

    function remove() {
        return axiosInstance.delete(`email-config/delete`);
    }
}
